import { createContext } from 'react';
import type { Site } from '@wix/site-list-client';

export interface SiteState {
  site: Site;
  setSite: (site: Site) => Promise<void>;
}

export const SiteContext = createContext<SiteState | null>(null);
